import type { NextPage } from 'next'
import { ArtworkAssistant } from '@/client/modules/ArtworkAssistant'
import { ArtworkAssistantProps } from '@/client/modules/ArtworkAssistant/types'
import { getCMSContent } from '@/client/utils'

const ArtworkAssistantPage: NextPage<ArtworkAssistantProps> = (data) => <ArtworkAssistant {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'ARTWORK_ASSISTANT')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ArtworkAssistantPage
